// Libraries
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components
import { YesNoConsent } from 'views/welcome/components';
import { AppearRight } from 'certn-ui/Animate';

// Modules
import withNavigation from 'views/welcome/modules/WithNavigation';

// Actions & Selectors
import { setTrackPageOrder, patchInformation } from 'views/welcome/WelcomeActions';
import { getInformation } from 'views/welcome/WelcomeSelectors';
import { PrivacyPolicyLink } from '../../../../certn-ui';

const BackgroundConsent = ({ handleNextTrack }) => {
    const dispatch = useDispatch();
    const isAPIConsentGiven = useSelector(getInformation)?.rcmp_consent_given || undefined;

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(setTrackPageOrder(['base']));
    }, [dispatch]);

    const handleSubmit = () => {
        dispatch(patchInformation({ rcmp_consent_given: true })).then(handleNextTrack);
    };

    return (
        <AppearRight>
            <YesNoConsent
                isAPIConsentGiven={isAPIConsentGiven}
                handleSubmit={handleSubmit}
                mainTitle={
                    <FormattedMessage
                        id="welcome.BackgroundConsent.title"
                        defaultMessage="We need your consent to run a Canadian criminal record check"
                    />
                }
                mainBody={
                    <FormattedMessage
                        id="welcome.BackgroundConsent.biometricConsent"
                        defaultMessage="To the extent permitted by applicable law, I hereby consent to a search of all records and information available at the time the search is conducted, including non-conviction information, charges before the courts, findings of guilt or convictions and court orders registered in my name in the National Repository of Criminal Records, the Canadian Police Information Centre (“CPIC”) database and local records available to the police service for the purposes of delivering a background screening report in relation to my application for employment with the Employer (“the Employer”). The query may also include a search of court records and a query of records management systems in other police agencies' jurisdictions through the Police Information Portal (PIP) or other data sharing systems.{br}I understand that this criminal record check is based on my identity verification including, but not limited to the name(s), date of birth and where used, the declared criminal record history provided by myself.{br}I acknowledge that for the completion of the criminal record check, reported criminal records may require me to provide fingerprints.{br}I acknowledge and agree that the Employer may collect, use and disclose the information collected for the purposes of evaluating my suitability for employment with the Employer.{br}I acknowledge that I have read and understood Certn’s {privacyPolicy} and hereby confirm that my consent is fully informed and freely given and I am aware that I can withdraw it at any time.{br}I acknowledge that if I do not consent to Certn’s and/or the Employer’s collection, use and disclosure of the information, this may result in my conditional offer of employment being void. Without a conditional offer of employment, I will not have an employment relationship with the Employer for any purposes.{br}You may request more information about the nature and scope of any criminal record checks to be conducted by contacting Certn’s Privacy Officer at 1-844-987-0690 or {privacyEmail}."
                        values={{
                            br: (
                                <>
                                    <br />
                                    <br />
                                </>
                            ),
                            privacyPolicy: <PrivacyPolicyLink />,
                            privacyEmail: (
                                <a style={{ display: 'contents' }} href="mailto:privacy@certn.co">
                                    privacy@certn.co
                                </a>
                            ),
                        }}
                    />
                }
            />
        </AppearRight>
    );
};

export default withNavigation(BackgroundConsent);
